export const digitsOnly = (value = "") => value.replace(/\D/g, "");

export const formatPhoneDisplay = (value = "") => {
    const d = digitsOnly(value).slice(0, 10); // limit to 10 digits
    if (d.length <= 3) return d;
    if (d.length <= 6) return `(${d.slice(0, 3)}) ${d.slice(3)}`;
    return `(${d.slice(0, 3)}) ${d.slice(3, 6)}-${d.slice(6)}`;
};
